module.exports = __webpack_public_path__ + "static/media/boxholmvapen.0fa8f922.png";